import { Navigate, Outlet } from 'react-router-dom';
import { getAdminToken } from '../../services/adminApi';

/**
 * AdminRoute - Protected Admin Route Guard
 *
 * Checks if user has a valid admin authentication token.
 * Uses the centralized adminApi token management (buzzbit_admin_token).
 * If token exists, renders child routes via Outlet.
 * If token is missing, redirects to /admin/login.
 */
const AdminRoute = () => {
  const adminToken = getAdminToken();

  if (!adminToken) {
    // Redirect to admin login if no admin token found
    return <Navigate to="/admin/login" replace />;
  }

  // Render child routes
  return <Outlet />;
};

export default AdminRoute;
